<template>
  <DsProcessSection
    title=""
    title-id="avaluos-process-title"
    intro="Tu camino está dividido en etapas claras. Aquí puedes entender qué sigue:"
    :steps="steps"
  >
    <template #title>¿Cómo es el <span class="hl">proceso?</span></template>
  </DsProcessSection>
</template>
<script setup lang="ts">
import DsProcessSection from '../components/DsProcessSection.vue'
const stages = [
  {
    title: 'Solicitud y Cotización',
    text: 'Solicita la cotización del avalúo y comparte la documentación requerida del inmueble, incluyendo el comprobante de pago del avalúo, para iniciar el trámite.',
    pad: true
  },
  {
    title: 'Integración de Requisitos',
    text: 'Un valuador se pondrá en contacto con la persona responsable de mostrar la propiedad para programar y realizar la visita al inmueble.',
    pad: true
  },
  {
    title: 'Emisión y Entrega',
    text: 'Una vez realizada la visita, el avalúo se entrega en un plazo máximo de 4 días hábiles, siempre que no existan incidencias. Si se detecta alguna observación o inconsistencia en el inmueble, esta deberá resolverse antes de concluir y compartir el avalúo con el cliente.',
    pad: false
  }
]
const steps = stages.map((stage, index) => ({ id: String(index + 1), title: stage.title, description: stage.text }))
</script>
